import { render, staticRenderFns } from "./configAdminDialog.vue?vue&type=template&id=1615f523&"
import script from "./configAdminDialog.vue?vue&type=script&lang=js&"
export * from "./configAdminDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports